
import './App.css';
import NavBar from './PageDetails/Navbar';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Project from "./pages/Project";
import Connect from "./pages/Connect";

function App() {
  return (
    <div className="App">
      <Router>
      <NavBar />
        <div className="pages">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/project" element={<Project />} />
            <Route path="/connect" element={<Connect />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
